const initialState = {
  devicesLoading: false,
  devices: [],
  selectedChannels: [],
  searchedChannels: [],
  isImage: false,
  date: { start: new Date(new Date().setHours(0, 0, 0, 0)), end: new Date(new Date().setHours(23, 59, 59, 59)) },
  progressbar_data_params: { error: [], success: [] },
  progressbar_data_image: { error: [], success: [] },
  externalFace: null,
  similarity: 89,
  cards_params: [],
  cards_image: [],
  activeTab: 3,
  filters: null,
  active_row: 0,
  selected_card: null,
  searchAll: false
}

const videoDetectionReducer = (state = initialState, action) => {
  switch (action.type) {
    // ?? Reset states
    case "SET_VIDEODETECTION_RESET_STATE":
      return action.data === "devices"
        ? {
            ...initialState,
            devices: state.devices,
            devicesLoading: state.devicesLoading,
            activeTab: state.activeTab
          }
        : initialState

    // ?? Devices
    case "SET_VIDEODETECTION_DEVICES_LOADING":
      return { ...state, devicesLoading: action.data }
    case "SET_VIDEODETECTION_DEVICES":
      return { ...state, devices: !state.devices ? action.data : [...state.devices, ...action.data] }
    case "SET_VIDEOTECTION_SELECTED_CHANNELS":
      return { ...state, selectedChannels: action.data }
    case "SET_VIDEOTECTION_SEARCHED_CHANNELS":
      return { ...state, searchedChannels: action.data }

    // ?? Filters
    case "SET_VIDEODETECTION_EXTERNAL_FACE":
      return { ...state, externalFace: action.data }
    case "SET_SIMILARITY_VIDEODETECTION":
      return { ...state, similarity: action.data }
    case "SET_VIDEOTECTION_DATE":
      return { ...state, date: action.data }
    case "SET_VIDEOTECTION_FILTERS":
      return { ...state, filters: action.data }
    case "SET_VIDEOTECTION_ACTIVE_ROW":
      return { ...state, active_row: action.data }
    case "SET_VIDEOTECTION_SELECTED_CARD":
      return { ...state, selected_card: action.data }
    case "SET_VIDEOTECTION_SEARCH_ALL":
      return { ...state, searchAll: action.data }

    // ?? Data
    case "SET_CARDS_PARAMS":
      return { ...state, cards_params: action.data }
    case "SET_CARDS_IMAGE":
      return { ...state, cards_image: action.data }

    case "SET_VIDEOTECTION_TAB":
      return { ...state, activeTab: action.data }
    case "SET_VIDEOTECTION_ISIMAGE":
      return { ...state, isImage: action.data }

    // ?? Progress
    case "SET_VIDEOTECTION_PROGRESSBAR_DATA_PARAMS":
      return { ...state, progressbar_data_params: action.data }
    case "SET_VIDEOTECTION_PROGRESSBAR_DATA_IMAGE":
      return { ...state, progressbar_data_image: action.data }

    default:
      return state
  }
}

export default videoDetectionReducer
